/** Core text and duration field handlers for the task form. */
import { useCallback } from 'react';
import {
  MIN_DURATION,
  processParentChange,
} from '@/features/tasks/utils/ui/taskFormUtils';

export const useTaskFormCoreFieldHandlers = ({
  setTask,
  allTasks,
  isRollup,
}) => {
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setTask((prev) => {
        const u = { ...prev, [name]: value };
        if (name === 'date' && prev.date && value !== prev.date) u.time = '';
        if (name === 'title' && value)
          u.title = value.charAt(0).toUpperCase() + value.slice(1);
        return u;
      });
    },
    [setTask],
  );

  const handleParentChange = useCallback(
    (_, opt) => setTask((p) => processParentChange(p, opt?.id, allTasks)),
    [allTasks, setTask],
  );

  const handleDurationChange = useCallback(
    (inc) =>
      !isRollup &&
      setTask((p) => ({
        ...p,
        duration: Math.max(MIN_DURATION, (p.duration || MIN_DURATION) + inc),
      })),
    [isRollup, setTask],
  );

  const handleDescriptionChange = useCallback(
    (h) => setTask((p) => ({ ...p, description: h })),
    [setTask],
  );

  return {
    handleChange,
    handleParentChange,
    handleDurationChange,
    handleDescriptionChange,
  };
};
